module.exports = __webpack_public_path__ + "img/hidro02.a16d9212.png";